module.exports = __webpack_public_path__ + "static/media/1.a44a8444.png";